import * as R from "ramda"

import cuckoo from "common/services/cuckoo/cuckoo"
import { cuckooEvents } from "common/consts/enums"

function trackPerf() {
  // safety for older browsers without 'performance.timing'
  if (!R.is(Object, window.performance) || !R.is(Object, window.performance.timing)) {
    cuckoo.track(cuckooEvents.GENERAL_PERFORMANCE_UNAVAILABLE, {
      error: "'performance.timing' not available",
    })

    return
  }

  const {
    requestStart, // request started from browser
    responseStart, // server started the response
    responseEnd, // recieved the last byte from the server
    domLoading, // parser started it's work
    domInteractive, // parser finished it's work
    domContentLoadedEventStart, // page parsed, initial scripts executed
    domContentLoadedEventEnd, // all scripts executed
    domComplete, // parser finished it's work on the main document
  } = window.performance.timing

  const START = requestStart
  const perf = {
    responseStart: responseStart - START,
    responseEnd: responseEnd - START,
    domLoading: domLoading - START,
    domInteractive: domInteractive - START,
    domContentLoadedEventStart: domContentLoadedEventStart - START,
    domContentLoadedEventEnd: domContentLoadedEventEnd - START,
    domComplete: domComplete - START,
  }

  cuckoo.track(cuckooEvents.GENERAL_PERFORMANCE, perf)
}

function onload() {
  trackPerf()
}

window.onload = onload
